import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import HouseKeepingContainer from './HouseKeeping';

export const HouseKeepingModule = () => (
  <Route exact path={APP_ROUTES.HOUSE_KEEPING_MODULE.PATH} component={HouseKeepingContainer} />
);